import { createEffect } from 'effector';
import { api } from '../../api/axiosinstance.js';

export const getCitiesFx = createEffect().use(async () => {
  return (await api(true).get('/data/cities')).data;
});

export const getHexListFx = createEffect().use(async (payload) => {
  return (await api(true).get(`/data/city/hex/list?city_id=${payload}`)).data;
});

export const getHexCollectionFx = createEffect().use(async (payload) => {
  return (await api(true).get(`/data/city/hex/collection?city_id=${payload}`))
    .data;
});

export const getFloodsAreaFx = createEffect().use(async (payload) => {
  return (
    await api(true).get(`/data/city/floods-areas/collection?city_id=${payload}`)
  ).data;
});

export const getMudfloodsAreaFx = createEffect().use(async (payload) => {
  return (
    await api(true).get(
      `/data/city/mudfloods-areas/collection?city_id=${payload}`
    )
  ).data;
});

export const getChartsDataByCitiesFx = createEffect().use(async (payload) => {
  return (
    await api(true).get(
      `/data/data_charts_by_cities${payload ? `?city_id=${payload}` : ''}`
    )
  ).data;
});
